import React from "react";
import type { ContentSection } from "../../../types/content-section.types";
import type { ProductSliderItem } from "../../products/ProductSlider/ProductSlider.shared";
import type { ContactUsProps } from "../../contact/contact-us-tiles/ContactUsTiles";
import ContentBlockRenderer from "./ContentBlockRenderer";

type Props = {
    section?: ContentSection | null;
    products?: ProductSliderItem[];
    contactUsProps?: ContactUsProps;
};

const ContentSectionRenderer = ({ section, products, contactUsProps }: Props) => {
    if (!section?.blocks?.length) return null;

    const blocks = [...section.blocks].sort(
        (a, b) => (a.order ?? 0) - (b.order ?? 0)
    );

    return (
        <>
            {blocks.map((block) => (
                <ContentBlockRenderer
                    key={block.id ?? `${block.type}-${block.order ?? 0}`}
                    block={block}
                    products={products}
                    contactUsProps={contactUsProps}
                />
            ))}
        </>
    );
};

export default ContentSectionRenderer;